module.exports = __webpack_public_path__ + "img/ym.64391688.jpeg";